/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

import DocSignElementType from "@/core/modules/DocSign/data/DocSignElementType";
import DocSignTextElement from "@/core/modules/DocSign/data/elements/DocSignTextElement";

export default class DocSignDateElement extends DocSignTextElement{


	dateFormat: string = "MM/DD/YYYY"
	isMultiline: boolean = false

	itemType: DocSignElementType = DocSignElementType.DATE

	constructor(left: number, top: number, width: number, height: number, type: string = DocSignElementType.DATE) {
		super(left, top, width, height, DocSignElementType.DATE);
		// this.resizeable = false //TODO disabling this requires font calculations. Maybe later...

	}


}
